// extracted by mini-css-extract-plugin
module.exports = {"HotelMapImage":"HotelMapImage_HotelMapImage__1YkV3"};